import React from "react";

export default function MaturaCircleTask21Diagram() {
  return (
    <svg
      viewBox="0 0 360 300"
      role="img"
      aria-label="Okrąg z punktami A, B, C, D i środkiem S"
      style={{ width: "min(100%, 390px)", height: "auto" }}
    >
      <circle
        cx="180"
        cy="150"
        r="112"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
      />

      <g fill="none" stroke="currentColor" strokeWidth="2.5">
        <line x1="94.2" y1="78" x2="265.8" y2="222" />
        <line x1="94.2" y1="78" x2="265.8" y2="78" />
        <line x1="265.8" y1="222" x2="180" y2="262" />
        <line x1="180" y1="262" x2="94.2" y2="78" />
        <line x1="180" y1="150" x2="265.8" y2="78" />
      </g>

      <g fill="var(--color-accent, #ff9800)" stroke="var(--color-bg, #050515)" strokeWidth="1.5">
        <circle cx="94.2" cy="78" r="4" />
        <circle cx="265.8" cy="222" r="4" />
        <circle cx="180" cy="262" r="4" />
        <circle cx="265.8" cy="78" r="4" />
        <circle cx="180" cy="150" r="4" />
      </g>

      <g
        fill="currentColor"
        fontFamily="KaTeX_Main, Georgia, serif"
        fontSize="20"
        fontStyle="italic"
      >
        <text x="72" y="66">D</text>
        <text x="276" y="236">B</text>
        <text x="174" y="288">C</text>
        <text x="278" y="70">A</text>
        <text x="163" y="145">S</text>
      </g>

      <g fill="var(--color-accent, #ff9800)" fontFamily="KaTeX_Main, serif" fontSize="17" fontWeight="700">
        <text x="134" y="101">40°</text>
        <text x="226" y="226">65°</text>
        <text x="230" y="140">36</text>
      </g>
    </svg>
  );
}
